import Vue from "vue"
import Router from "vue-router"
import { isMobile } from "@/utils/deviceDetect"
import { desktopRoutes } from "./desktop"
import { mobileRoutes } from "./mobile"
import store from "@/store"

const routes = isMobile() ? mobileRoutes : desktopRoutes //mobileRoutes //

Vue.use(Router)
const router = new Router({
  mode: "history",
  routes
})

router.beforeEach((to, from, next) => {
  const isLogged = store.getters["auth/isLogged"]
  const publicPages = ["/login", "/register", "/password", "/demo", "/home"]
  const authRequired = !publicPages.includes(to.path)
  authRequired && !isLogged ? next("/login") : next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js